var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoinTopButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.772,
    height: 16.526,
    viewBox: "0 0 13.772 16.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Enter",
    d: "M6.754,4.836V6.673a.918.918,0,1,1-1.836,0V4.653A1.653,1.653,0,0,1,6.571,3h9.549a1.653,1.653,0,0,1,1.653,1.653V17.874a1.653,1.653,0,0,1-1.653,1.653H6.571a1.653,1.653,0,0,1-1.653-1.653v-2.02a.918.918,0,1,1,1.836,0V17.69h9.181V4.836Zm4.08,7.365-5.918-.02a.918.918,0,0,1,0-1.836l5.934.02v-.02L9.7,9.19a.964.964,0,1,1,1.363-1.363l2.754,2.754a.964.964,0,0,1,0,1.363L11.063,14.7A.964.964,0,1,1,9.7,13.336Z",
    transform: "translate(-4 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinTopButton);
export default __webpack_public_path__ + "static/media/joinTopButton.cffb44b9ca1504906c54b84f7a99b2ff.svg";
export { ForwardRef as ReactComponent };